import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=6c99291d&scoped=true"
var script = {}
import style0 from "./TitleSection.vue?vue&type=style&index=0&id=6c99291d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99291d",
  null
  
)

export default component.exports